/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtpRes } from '../../models/otp-res';
import { OtpSmsRegReq } from '../../models/otp-sms-reg-req';

export interface ApiUserRegisterOtpSmsPost$Params {
      body?: OtpSmsRegReq
}

export function apiUserRegisterOtpSmsPost(http: HttpClient, rootUrl: string, params?: ApiUserRegisterOtpSmsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRes>> {
  const rb = new RequestBuilder(rootUrl, apiUserRegisterOtpSmsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OtpRes>;
    })
  );
}

apiUserRegisterOtpSmsPost.PATH = '/api/User/register-otp-sms';
